var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MessageView',{attrs:{"title":"No Issues Found","message":"There are no issues found for the given vessel and date range."}})}
var staticRenderFns = []

export { render, staticRenderFns }